import React from 'react'
import Question from './Question'

const Faq = () => {
  return (
    <>
      <div id='faq'></div>
      <article className='px-8 my-16 text-center'>
        <div className='rounded-xl shadow-[0px_2px_4px_2px_rgba(0,0,0,0.05)] pt-8 max-w-[520px] md:max-w-[640px] lg:max-w-[1080px] mx-auto'>

          <div className='px-4'>
            <h2 className='font-bold text-2xl md:text-3xl lg:text-4xl mb-2'>Frequently Asked Questions</h2>
            <p className='text-sm md:text-lg lg:text-xl text-[#22222f] mb-6 md:mb-8 lg:mb-12'>We got this question a lot!</p>
          </div>

          <Question question='Do I need cash?'>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris rcitation ullamco laborisrcitation ullamco laboris rcitation ullamco laboris rcitation ullamco laboris rcitation ullamco laborisrcitation ullamco laboris rcitation ullamco laborisrcitation ullamco laborisrcitation ullamco laborisrcitation ullamco laborisrcitation ullamco laborisrcitation ullamco laboris
          </Question>
          <Question question='Do I need money?'>
            No apasih nanya kok gini gini amat, gaada pertanyaan yang lebih bermutu apa, ya pasti namanya bisnis orang butuh uang. Kok bisa minta ga bayar gitu lho aneh banget.
          </Question>
          {/* <div className='px-8 py-6 border-b-[#E4E4E7] border-b-[1px] flex justify-between text-left'>
            <p className='font-bold text-xl'>Are larger bags are more expensive?</p>
            <p className='font-bold text-xl'>+</p>
          </div> */}
        </div>
      </article>
    </>
  )
}

export default Faq